export default "__VITE_ASSET__wEiKfKjr__"